import { PageCardTokenActions } from './Actions';
import { PageCardTokenApiResponse } from './ApiResponse';
import { PageCardToken } from './CardToken';
import { PageCardTokenEvents } from './Events';
import { PageCardTokenInformation } from './Information';
import { PageCardTokensOverview } from './Overview';

export { PageCardTokensOverview } from './Overview';

export const CARD_TOKENS = {
  CardTokens: PageCardTokensOverview,
  CardTokenSection: PageCardToken,
  CardTokenInformation: PageCardTokenInformation,
  CardTokenEvents: PageCardTokenEvents,
  CardTokenActions: PageCardTokenActions,
  CardTokenApiResponse: PageCardTokenApiResponse,
} as const;
